import { createContext } from "react";

export type ProjectFormPageKey = 'organisation' | 'overlay' | 'validation' | 'measures' | 'processes' | 'extraction' | 'copy';

export interface ProjectFormNavigationContextProps {
    route: ProjectFormPageKey;
    setRoute: (route: ProjectFormPageKey, queryParams?: URLSearchParams, from?: ProjectFormPageKey) => void;
    
    hasParam: (paramName: string) => boolean;
    getParam: <T extends string = string>(paramName: string) => T | undefined;
    getFrom: () => ProjectFormPageKey | undefined;
}

export const ProjectFormNavigationContext = createContext<ProjectFormNavigationContextProps | undefined>(undefined);